import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Ref } from "semantic-ui-react";
import { observable } from "mobx";
import StickyMenu from "~/components/StickyMenu";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ToastMessageStore from "~/stores/ToastMessageStore";
import ToastMessageContainer from "~/components/ToastMessageContainer";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import UiMeet3dLayoutWrapper from "~/modules/UiMeet3d/components/UiMeet3dLayoutWrapper";
import UiMeet3dNav from "~/modules/UiMeet3d/constants/UiMeet3dNav";
import PaginatedTable from "~/components/PaginatedTable";
import ContentLoader from "~/components/element/ContentLoader";
import RouteWrapper from "~/components/wrapper/RouteWrapper";
import UiMeet3dActivityLogStore from "~/stores/UiMeet3d/UiMeet3dActivityLogStore";
import UiMeet3dActivityLogTable from "~/modules/UiMeet3d/components/UiMeet3dActivityLogTable";

@observer
class UiMeet3dCompletedMeetingIndexPage extends Component {
  ref = null;

  @observable uiMeet3dActivityLogStore = null;

  constructor(props) {
    super(props);

    const { t } = props;

    this.ref = createRef();
    document.title = `${t("uiMeet3d")} - ${t("clientPanelMisc:meetings")}`;

    this.uiMeet3dActivityLogStore = new UiMeet3dActivityLogStore();
  }

  componentDidMount() {
    const { showError } = this.props;

    this.uiMeet3dActivityLogStore.loadIndex().catch(error => showError(error.message));
  }

  render() {
    const { showError, t, toastMessageStore, replaceQuery } = this.props;
    const { pagination, isLoading, uiMeet3dActivityLogs } = this.uiMeet3dActivityLogStore;

    return (
      <>
        <LoadingWrapper loading={false} message={t("saving")} />
        <div className="side-page-outer-container" style={{ marginTop: "0" }}>
          <Ref innerRef={this.ref}>
            <div>
              <StickyMenu contextRef={this.ref} headerText={t("clientPanelMisc:meetings")} />
              {isLoading ? (
                <ContentLoader />
              ) : (
                <PaginatedTable
                  pagination={pagination}
                  changePageCallback={page => {
                    this.uiMeet3dActivityLogStore.changePage(page).catch(error => showError(error.message));
                    replaceQuery({ page });
                  }}
                  totalItemsCount={uiMeet3dActivityLogs.length}
                >
                  <UiMeet3dActivityLogTable uiMeet3dActivityLogs={uiMeet3dActivityLogs} />
                </PaginatedTable>
              )}
            </div>
          </Ref>
        </div>
        <ToastMessageContainer toastMessageStore={toastMessageStore} />
      </>
    );
  }
}

UiMeet3dCompletedMeetingIndexPage.propTypes = {
  t: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
  showError: PropTypes.func.isRequired,
};

export default withTranslation()(
  ErrorWrapper(RouteWrapper(UiMeet3dLayoutWrapper(UiMeet3dCompletedMeetingIndexPage, UiMeet3dNav.COMPLETED_MEETINGS))),
);
